<div class="wrapper">
  <div [ngSwitch]="dataState">
    <loading-state *ngSwitchCase="DataState.Loading"></loading-state>
    <ng-container *ngSwitchCase="DataState.Error">
      <div class="data-state__error">
        <ion-icon style="font-size: xx-large;" color="primary" name="warning"></ion-icon>
        <p>Betaling QR niet beschikbaar</p>
        <ion-button color="secondary" (click)="loadData()">Probeer opnieuw</ion-button>
      </div>
    </ng-container>
    <div *ngSwitchCase="DataState.None">
      <div class="payment__info">
        <p>TOTAAL: {{data.order.order.totalPrice | currency: 'EUR' }}</p>
      </div>
      <img [src]="imagePath">
    </div>
  </div>
</div>